import _objectWithoutProperties from "/Users/preetpalsingh/CodeBase/six-respondent-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { themeHelpers } from './helpers';
import get from 'lodash/get';

function parseLssProp(styles, lss, theme, rootLss) {
  var keys = Object.keys(lss);
  var length = keys.length;

  var _loop = function _loop(i) {
    var lssProp = keys[i];
    var value = lss[lssProp];

    if (value === null || value === undefined) {
      return "continue";
    } // If the prop is a breakpoint breakpoints


    if (typeof theme.breakpoints[lssProp] !== 'undefined') {
      styles["@media (min-width: ".concat(theme.breakpoints[lssProp], ")")] = parseLssProp({}, value, theme, rootLss || lss);
      return "continue";
    } // Pseudo Selectors and custom classes
    // is an object, let's parse it for the children


    if (typeof value === 'object') {
      styles[lssProp] = parseLssProp({}, value, theme, rootLss || lss);
      return "continue";
    }

    var helper = themeHelpers[lssProp];

    if (!helper) {
      if (lssProp === 'content') {
        styles[lssProp] = "\"".concat(value, "\"");
      } else {
        if (typeof value === 'function') {
          value = value({
            theme: theme,
            lss: rootLss || lss
          });
        }

        styles[lssProp] = value;
      }

      return "continue";
    }

    var key = undefined;
    var cssProp = lssProp; // helper is a string, we assume is a key on the theme

    if (typeof helper === 'string') {
      key = helper;
    } else if (typeof helper === 'object') {
      if ('key' in helper) {
        key = helper.key;
      }

      if (typeof helper.css !== 'undefined') {
        cssProp = helper.css;
      }
    }

    if (typeof value === 'function') {
      value = value({
        theme: theme,
        lss: rootLss || lss
      });
    }

    if (key !== undefined) {
      var themeValue = get(theme[key], value);
      value = themeValue || value;
    }

    if (Array.isArray(cssProp)) {
      cssProp.forEach(function (css) {
        styles[css] = value;
      });
    } else if (typeof value === 'object') {
      Object.assign(styles, value);
    } else {
      styles[cssProp] = value;
    }
  };

  for (var i = 0; i < length; i++) {
    var _ret = _loop(i);

    if (_ret === "continue") continue;
  }

  return styles;
}

function parseDefault(lss, props, defaults) {
  return typeof defaults === 'function' ? Object.assign({}, defaults(props), lss) : typeof defaults === 'object' ? Object.assign({}, defaults, lss) : lss;
}

export var themeLss = function themeLss(defaults) {
  return function (_ref) {
    var theme = _ref.theme,
        _ref$lss = _ref.lss,
        lss = _ref$lss === void 0 ? {} : _ref$lss,
        props = _objectWithoutProperties(_ref, ["theme", "lss"]);

    var result = parseLssProp({}, parseDefault(lss, props, defaults), theme);
    return result;
  };
};